export type TanstackQueriesSchema = {
  key: string;
  value: {
    buster: string;
    queryHash: string;
    queryKey: string[];
    state: object;
  };
};

export const tanstackQueriesSchema = '&key, value';
